var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9479_29539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 7.5V12L16 14.25",
    stroke: "#0A77A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.75H21.25V6",
    stroke: "#0A77A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9125 17.9999C16.7331 19.1127 15.252 19.8533 13.6541 20.1292C12.0563 20.4051 10.4125 20.204 8.92833 19.5511C7.4441 18.8981 6.1852 17.8222 5.30893 16.4579C4.43265 15.0936 3.97785 13.5013 4.00136 11.8799C4.02486 10.2586 4.52563 8.68013 5.44109 7.34177C6.35655 6.00341 7.6461 4.9645 9.14863 4.35485C10.6512 3.74519 12.3 3.59182 13.8892 3.91391C15.4784 4.23599 16.9375 5.01925 18.084 6.16581C19.1875 7.28331 20.0987 8.33706 21.25 9.74987",
    stroke: "#0A77A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9479_29539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronClock);
export default __webpack_public_path__ + "static/media/chevron-clock.d5c371d9ea9a453f13ebf0ad038493ad.svg";
export { ForwardRef as ReactComponent };